// extracted by mini-css-extract-plugin
module.exports = {"exam_analysis_right_viewer_wrapper":"RightViewer_exam_analysis_right_viewer_wrapper__2p9CG"};